import React, { useRef } from 'react';
import { useSelector } from "react-redux";
import { TransformerProvider } from './TransformerContext';
import {
  Box, Button, Stack,
  Divider, ButtonGroup,
  Typography
} from '@mui/material';
import html2canvas from 'html2canvas';
import {

  BsCircle, BsTextareaT, BsTriangle, BsEye, BsEyeSlash,
  BsTransparency,
  BsXLg, BsBoundingBox, BsDownload, BsArrowUpRight, BsBezier, BsBezier2,
  BsChat, BsBrush, BsPencil, BsTrash3, BsSquare, BsPentagon, BsPrinter,
  BsTypeBold, BsTypeItalic, BsTextCenter, BsTextLeft, BsTextRight, BsPaintBucket, BsBorderWidth,
  BsCaretDownFill,
  BsJustify, BsFloppyFill, BsShareFill
} from "react-icons/bs";
import { downloadImage, naviIcons, printImage, shareIcon } from '../../Tools';

import { ReactComponent as Hide } from "../../../../assets/tool/24/Hide24.svg";
import { ReactComponent as Show } from "../../../../assets/tool/24/Show24.svg";
import { ReactComponent as Print } from "../../../../assets/tool/24/Print24.svg";
import { ReactComponent as Download } from "../../../../assets/tool/24/Download24.svg";
import { ReactComponent as Arrow } from "../../../../assets/tool/16/Arrow_tool16.svg";
import { ReactComponent as Bezier } from "../../../../assets/tool/16/Bezier-curve16.svg";
import { ReactComponent as Brush } from "../../../../assets/tool/24/Paint_brush24.svg";
import { ReactComponent as Circle } from "../../../../assets/tool/16/Circle16.svg";
import { ReactComponent as Comment } from "../../../../assets/tool/16/Comment16.svg";
import { ReactComponent as CurvedArrow } from "../../../../assets/tool/16/Curved_arrow_tool_16.svg";
import { ReactComponent as LineThickness } from "../../../../assets/tool/16/Line_Thickness1616.svg";
import { ReactComponent as Opacity } from "../../../../assets/tool/16/Opacity16.svg";
import { ReactComponent as Pen } from "../../../../assets/tool/16/Pen16.svg";
import { ReactComponent as Pencil } from "../../../../assets/tool/16/Pencil16.svg";
import { ReactComponent as Paint } from "../../../../assets/tool/24/Paint_brush24.svg";
import { ReactComponent as Pentagon } from "../../../../assets/tool/16/Pentagon16.svg";
import { ReactComponent as Select } from "../../../../assets/tool/16/Select16.svg";
import { ReactComponent as Square } from "../../../../assets/tool/16/Square16.svg";
import { ReactComponent as Text } from "../../../../assets/tool/16/Text16.svg";
import { ReactComponent as Triangle } from "../../../../assets/tool/16/Triangle16.svg";
import { ReactComponent as Brush16 } from "../../../../assets/tool/16/Brush16.svg";
import { ReactComponent as Delete } from "../../../../assets/tool/24/Delete24.svg";

import { DropDown } from '../../Tools';
import { FaSprayCanSparkles } from 'react-icons/fa6';
import CSlider from '../CSlider';
import Canvas from './Canvas';
import ColorPicker from '../colors/ColorPicker';
import './main.css'
import NaviBox from '../../../../extra2/NaviBox';
import ZoomSlider from '../../../../extra2/ZoomSlider';
import ShareBox from '../../../extra/ShareBox';
import { useDispatch } from 'react-redux';
import { SENDEMAIL, MARKUP, MARKUPALL } from '../../../../services/actions';
const btnStyle = {
  textTransform: 'capitalize',
  borderRadius: 0, px: 0.7, height: '100%',
  borderColor: '#373737ff', color: 'white',
  border: 'none', display: 'flex', gap: 1, alignItems: 'center'
}


export default function Photoshop({ onClose = () => { },
  imgSrc = 'https://app.widelapse.com/media/midm2750bd04-rlic3c54937d-time29377ee5/2025-07-23/000217.jpg',
  selectedCamera }) {
  const dispatch = useDispatch();
  const [shapes, setShapes] = React.useState([]);
  const [shape, setShape] = React.useState({});
  const [shapeType, setShapeType] = React.useState("");
  const [download, setDownload] = React.useState(null);
  const [changedProp, setChangedProp] = React.useState({});
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [fontSize, setFontSize] = React.useState(16);
  const [filter, setFilter] = React.useState({ filter: '' })
  const [dynaSrc, setDynaSrc] = React.useState(imgSrc)
  const [shareSrc, setShareSrc] = React.useState(imgSrc)
  const markupallState = useSelector((state) => state?.markupallState);
  const [tool, setTool] = React.useState({ zoom: 0, x: 0, y: 0 });
  const trigerRef = useRef();

  const getMarkup = (id = 0) => {
    const url = `save-markup-image/${id}/`;// pass page number   
    dispatch({ type: `${MARKUPALL}_GET`, payload: url });
  }
  React.useEffect(() => {
    if (selectedCamera?.id) {
      getMarkup(selectedCamera?.id)
    }
  }, selectedCamera)

  const onFilterChange = (value, type) => {
    let filter = {
      blur: 0, brightness: 100, contrast: 100,
      grayscale: 0, huerotate: 0, invert: 0,
      opacity: 100,
      saturate: 100,
      sepia: 0,
    }
    filter[type] = value
    setFilter(filter)
    // setFilter({
    //   filter: `blur(${filter.blur}px) brightness(${filter.brightness}%) contrast(${filter.contrast}%) grayscale(${filter.grayscale}%) hue-rotate(${filter.huerotate}deg) invert(${filter.invert}%) opacity(${filter.opacity}%) saturate(${filter.saturate}%) sepia(${filter.sepia}%)`
    // })
  }
  function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }
  const addShape = (type, subType = null, props = { strokeWidth: 2, fill: 'white', stroke: 'black', textColor: 'black', fontSize: 12 }) => {
    setShapeType(type)
    const newId = `${type}-${Date.now()}`;
    setSelectedIds([newId])
    const newShape = {
      id: newId,
      type,
      subType,
      x: randomBetween(((window.innerWidth / 2) - 200), ((window.innerWidth / 2))),
      y: randomBetween(((window.innerHeight / 2) - 200), ((window.innerHeight / 2))),
      props
    };
    setShape(newShape)
    setShapes([...shapes, newShape]);
  };

  const webSafeFonts = [
    'Arial', 'Verdana', 'Helvetica', 'Tahoma', 'Trebuchet MS',
    'Times New Roman', 'Georgia', 'Courier New', 'Lucida Console', 'Palatino Linotype'
  ];

  const changeProps = (prop) => {
    setChangedProp((prev => ({ ...prev, ...prop })))
    const updated = shapes.map(shape => {
      if (selectedIds.includes(shape.id)) {
        shape.props = { ...shape.props, ...prop }
        return shape
      }
      return shape
    })
    //updated[selectedId].fontSize = parseInt(e.target.value, 10);
    setShapes([...updated]);
  }
  const hideEle = () => {
    const updated = shapes.map(shape => {
      if (selectedIds.includes(shape.id)) {
        shape.hide = true
        return shape
      }
      return shape
    })
    //updated[selectedId].fontSize = parseInt(e.target.value, 10);
    setShapes(updated);
    setSelectedIds([])
  }
  const showEle = (ids) => {
    const updated = shapes.map(shape => {
      if (ids.includes(shape.id)) {
        shape.hide = false
        return shape
      }
      return shape
    })
    //updated[selectedId].fontSize = parseInt(e.target.value, 10);
    setShapes(updated);
  }
  const onNaviChange = (status) => {
    if (status == "zoom-in") {
      trigerRef.current?.zoomStage("in")
      setTool((prev) => ({ ...prev, zoom: prev.zoom + 1 }))
    }
    if (status == "zoom-out") {
      trigerRef.current?.zoomStage("out")
      setTool((prev) => ({ ...prev, zoom: prev.zoom - 1 }))
    }
    if (status == "left") {
      trigerRef.current?.moveStage(-100, 0)
    }
    if (status == "right") {
      trigerRef.current?.moveStage(100, 0)
    }
    if (status == "up") {
      trigerRef.current?.moveStage(0, -100)
    }
    if (status == "down") {
      trigerRef.current?.moveStage(0, 100)
    }
  }
  const CustomIcon = ({ icon, label, value }) => {
    return <Box sx={{ textAlign: 'center', display: 'flex', gap: 0.5, alignItems: 'center', height: 40, width: 42 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {icon}
      </Box>
      {label == "text" && <Box sx={{ p: 0.4, color: 'white', border: '1px solid #d2d2d2ff', borderRadius: 1, width: 40, height: 24 }}>{value}</Box>}
      {label != "text" && <Box sx={{ p: 0.4, color: 'white', border: '1px solid #d2d2d2ff', background: value, borderRadius: 1, width: 40, height: 24 }}></Box>}
    </Box>
  }
  return (
    <Box className="markup" sx={{ width: 1, p: 0, margin: 'auto', userSelect: 'none', position: 'relative', height: 1 }}>
      <Stack className="tool-bar" direction="row" spacing={2} sx={{ p: 1.5 }}>
        <Box display={'flex'} alignItems={'center'} gap={3}>
          {/* 1. TITLE (Fixed Left) */}
          <Typography sx={{
            color: '#FFD700',
            fontWeight: 'bold',
            fontSize: '22px',
          }}>
            Markup
          </Typography>
          {/* <Divider orientation="vertical" flexItem sx={{ bgcolor: '#696969' }} /> */}
          <Box display={'flex'} alignItems={'center'} gap={1}>
            <DropDown
              customIcon={<CustomIcon
                icon={<Paint title='Fill color' width={16} height={16} />}
                label="background" value={changedProp?.fill} />}
            >
              <Box>
                <ColorPicker onChange={(color) => changeProps({ fill: color })} />
              </Box>
            </DropDown>
            <DropDown
              customIcon={<CustomIcon
                icon={<Pencil title='Fill color' width={16} height={16} />}
                label="background" value={changedProp?.stroke} />}
            >
              <Box>
                <ColorPicker onChange={(color) => changeProps({ stroke: color })} />
              </Box>
            </DropDown>
            <DropDown
              customIcon={<CustomIcon
                icon={<LineThickness title='Border width' />}
                label="text" value={changedProp?.strokeWidth} />}
            >
              <Box sx={{ minWidth: 120, p: 1 }}>
                {[8, 7, 6, 5, 4, 3, 2, 1].map((i) => <Box
                  onClick={() => changeProps({ strokeWidth: i })}
                  sx={{ borderRadius: 1, p: 1, border: '1px solid gray', marginBottom: 0.5 }}>
                  <Box sx={{ borderTop: `${i}px solid white` }} />
                </Box>)}
              </Box>
            </DropDown>
            <DropDown
              customIcon={<CustomIcon
                icon={<Opacity title='Fill color transparency' />}
                label="text" value={changedProp?.opacity} />}

            >
              <Box sx={{ minWidth: 120, p: 1 }}>
                {[1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1, 0.0].map((i) => <Box
                  onClick={(color) => changeProps({ opacity: i })}>
                  <Box sx={{ background: 'white', opacity: `${i}`, height: 10, mt: 0.5 }} />
                </Box>)}
              </Box>
            </DropDown>
          </Box>
          <Divider orientation="vertical" flexItem sx={{ bgcolor: '#696969' }} />
          <Box sx={{ color: 'white' }} display={'flex'} alignItems={'center'} gap={1}>
            <DropDown customIcon={<Box sx={{}}><Typography sx={{ color: 'white' }} fontSize={16}>{'Arial'}</Typography></Box>}>
              <Box sx={{ width: 120, px: 2 }}>
                {webSafeFonts.map((font) => <Typography fontSize={16} onClick={() => changeProps({ fontFamily: font })}>{font}</Typography>)}
              </Box>
            </DropDown>
            <Box>
              <DropDown customIcon={<Typography title='Text Color' sx={{ borderBottom: `4px solid ${(changedProp?.textColor || 'red')}`, fontWeight: 800, px: 0.5, lineHeight: 0.8 }} fontSize={14}>{'A'}</Typography>}>
                <Box>
                  <ColorPicker onChange={(color) => changeProps({ textColor: color })} />
                </Box>
              </DropDown>
            </Box>
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <Box onClick={() => { setFontSize((prev) => prev - 1); changeProps({ fontSize: fontSize }) }}>-</Box>
              <Box><input value={fontSize} style={{ minWidth: 40, fontSize: 14, color: 'white', textAlign: 'center', background: 'none', maxWidth: 50, padding: 5, height: 20 }} onChange={(e) => { setFontSize(e.target.value); changeProps({ fontSize: e.target.value }) }} /></Box>
              <Box onClick={() => { setFontSize((prev) => prev + 1); changeProps({ fontSize: fontSize }) }}>+</Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <BsTypeBold fontSize={16} onClick={() => changeProps({ fontStyle: 'bold' })} />
              {/* <BsTypeUnderline onClick={() => changeProps({ fontWeight: 800 })} /> */}
              <BsTypeItalic title='Italic' fontSize={16} onClick={() => changeProps({ fontStyle: 'italic' })} />
              <BsTextLeft title='Text Left' fontSize={16} onClick={() => changeProps({ align: 'left' })} />
              <BsTextCenter title='Text Center' fontSize={16} onClick={() => changeProps({ align: 'center' })} />
              <BsTextRight title='Text Right' fontSize={16} onClick={() => changeProps({ align: 'right' })} />
              <BsJustify title='Text Justify' fontSize={16} onClick={() => changeProps({ align: 'justify' })} />
            </Box>
          </Box>
          <Divider orientation="vertical" flexItem sx={{ bgcolor: '#696969' }} />
          <Box
            color="error"
            sx={{ p: 0, minWidth: 8 }}
            onClick={() => {
              if (Array.isArray(selectedIds) && selectedIds.length === 0) {
                return false
              }
              setShapes(shapes.filter(shape => !selectedIds.includes(shape.id)));
              setSelectedIds([]);
            }}
          // disabled={Array.isArray(selectedIds) && selectedIds.length === 0}
          >
            <Delete title='Delete seleted' width={16} height={16} />
          </Box>
          <Divider orientation="vertical" flexItem sx={{ bgcolor: '#696969' }} />
        </Box>
        <Box display={'flex'} alignItems={'center'} gap={1} sx={{ width: 1 }}>
          <DropDown customIcon={<Box sx={{}}><FaSprayCanSparkles style={{ color: 'white' }} fontSize={16} title='Background Filter' /></Box>}>
            <Box sx={{ width: 210, px: 2 }}>
              <CSlider MAX={10} MIN={0} step={1} label="blur" onChange={(v) => { onFilterChange(v, "blur") }} />
              <CSlider MAX={200} MIN={0} defaultValue={100} step={10} label="brightness" onChange={(v) => { onFilterChange(v, "brightness") }} />
              <CSlider MAX={200} MIN={0} defaultValue={100} step={10} label="contrast" onChange={(v) => { onFilterChange(v, "contrast") }} />
              <CSlider MAX={100} MIN={0} defaultValue={0} step={10} label="grayscale" onChange={(v) => { onFilterChange(v, "grayscale") }} />
              <CSlider MAX={360} MIN={0} defaultValue={0} step={10} label="huerotate" onChange={(v) => { onFilterChange(v, "huerotate") }} />
              <CSlider MAX={100} MIN={0} defaultValue={0} step={10} label="invert" onChange={(v) => { onFilterChange(v, "invert") }} />
              <CSlider MAX={100} MIN={0} defaultValue={100} step={10} label="opacity" onChange={(v) => { onFilterChange(v, "opacity") }} />
              <CSlider MAX={200} MIN={0} defaultValue={100} step={10} label="saturate" onChange={(v) => { onFilterChange(v, "saturate") }} />
              <CSlider MAX={100} MIN={0} defaultValue={0} step={10} label="sepia" onChange={(v) => { onFilterChange(v, "sepia") }} />
            </Box>
          </DropDown>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <BsEyeSlash style={{ color: 'white' }} title='Show Hide Component' fontSize={16} onClick={() => hideEle()} />
            <DropDown customIcon={<BsCaretDownFill style={{ color: 'white' }} fontSize={10} />}>
              <Box sx={{ width: 120, px: 1 }}>
                {shapes?.length == 0 && <Typography fontSize={11}>No objects available</Typography>}
                {shapes.map((d) => {
                  if (!d.hide) return
                  return <><Box onClick={() => showEle([d.id])}><BsEye />{d.id}</Box></>
                })}
              </Box>
            </DropDown>

            <Box sx={btnStyle} onClick={() => { setDownload(true); setTimeout(function () { setDownload("export"); }, 10) }}>
              <Download title='Download' width={18} height={18} />
            </Box>
            <Box sx={btnStyle} onClick={() => { setDownload(true); setTimeout(function () { setDownload("print"); }, 10) }}>
              <Print title='Print' width={18} height={18} />
            </Box>
            <Box sx={btnStyle} onClick={() => { setDownload(true); setTimeout(function () { setDownload("save"); }, 10) }}>
              <BsFloppyFill title='Print' width={16} height={16} />
            </Box>
            {/* {========================================} */}
            <DropDown right={true} customIcon={<Box sx={btnStyle}
              onMouseEnter={() => { setDownload(true); setTimeout(function () { setDownload("share"); }, 10) }}
            ><BsShareFill style={{ color: 'white' }} size={14} /></Box>}>
              {/* <Box color="red" maxWidth={100} sx={{ overflow: 'auto' }}> {JSON.stringify(shareSrc)} </Box> */}
              <ShareBox
                imgType='base64'
                keepMenu={[2]}
                activeView={0}
                url={shareSrc}
                icons={shareIcon.map(([label, vi, icon]) => {
                  console.log("ICONS", vi)
                  if (vi == 7) {
                    return <Box title={label} onClick={() => { setDownload(true); setTimeout(function () { setDownload("share"); }, 10) }} className="tool-menu tool-submenu">{icon}</Box>
                  }
                  return null
                  // if ([9, 10, 11].includes(vi)) {
                  //   const fileName = `markup_${selectedCamera.camera_name}.jpg`
                  //   if ([11].includes(vi)) return <Box onClick={() => { printImage(dynaSrc, null, "", fileName, selectedCamera?.camera_name) }} title={label} className="tool-submenu">{icon}</Box>
                  //   return <Box onClick={() => { downloadImage(shareSrc, null, "", fileName) }} title={label} className="tool-submenu">{icon}</Box>
                  // }
                  // return <Box title={label} onClick={() => { setDownload(true); setTimeout(function () { setDownload("share"); }, 10) }} className="tool-menu tool-submenu">{icon}00</Box>
                })}
                onSubmit={(data, reset) => {
                  if (shareSrc) {
                    data["camera"] = selectedCamera.id
                    data["timestamp"] = new Date().toUTCString()
                    data["message"] = `${selectedCamera?.company_name}/${selectedCamera?.project_name}/${selectedCamera?.camera_name}`
                    data["img_url"] = shareSrc
                    dispatch({ type: SENDEMAIL + "_POST", payload: data })
                    reset()
                  }
                }}
              />
            </DropDown>
            {/* ==================================== */}
          </Box>
          <Box sx={{ textAlign: 'right', width: 1, flexGrow: '1 1' }}>

          </Box>
          <Box sx={{ color: '#ffd80c', fontSize: 20, fontWeight: 900 }}>
            <BsXLg title='Close' onClick={onClose} />
          </Box>

        </Box>
        {/* <Box display={'flex'} alignItems={'center'} sx={{}} onClick={(e) => { downloadBoxAsPNG(true) }}><FaPrint /></Box> */}
      </Stack>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: 1 }}>
        <Box className="tool-bar" sx={{ pb: 15 }}>
          <ButtonGroup orientation="vertical" variant="text" sx={{ ...btnStyle, py: 2 }}>
            {/* Udpate for the color in line of MarkUp*/}
            <Button sx={btnStyle} onClick={() => addShape('selection')}><Select title='Selection' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('arrow', 'normal', { stroke: "#ff0000" })}><Arrow title='Arrow' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('arrow', 'bez', { stroke: "#ff0000" })}><Bezier title='Bezier' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('arrow', 'quad', { stroke: "#ff0000" })}><CurvedArrow title='Quantratic' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('text', null)}><Text title='Textbox' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('callout', null, { stroke: "#ff0000" })}><Comment title='Callout' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('freehand', null, { drawing: true, stroke: "#ff0000" })}><Pencil title='Pencil' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('freehand', null, { drawing: true, strokeWidth: 5, stroke: "#ff0000" })}><Brush16 title='Brush' /></Button>
            {/* End  of udpate for the color in line of MarkUp*/}
            <Button
              color="error"
              sx={btnStyle} onClick={() => {
                setShapes(shapes.filter(shape => !selectedIds.includes(shape.id)));
                setSelectedIds([]);
              }}
              disabled={Array.isArray(selectedIds) && selectedIds.length === 0}
            >
              <Delete title='Delete seleted' width={16} height={16} />
            </Button>

            <Button sx={btnStyle} onClick={() => addShape('rectangle', null, {
              drawing: true, fill: "white",
              stroke: "#ff0000",
              strokeWidth: 1,
              draggable: true
            })}><Square title='Rectangle' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('triangle', null, {
              drawing: true, fill: "white",
              stroke: "#ff0000",
              strokeWidth: 1,
              draggable: true
            })}><Triangle title='Triangle' /></Button>
            <Button sx={btnStyle} onClick={() => addShape('circle', null, {
              drawing: true, fill: "white",
              stroke: "#ff0000",
              strokeWidth: 1,
              draggable: true
            })}><Circle title='Circle' /></Button>

            <Button sx={btnStyle} onClick={() => addShape('polygon', null, {
              drawing: true, fill: "white",
              stroke: "#ff0000",
              strokeWidth: 1,
              draggable: true
            })}><Pentagon title="Polygon" /></Button>

            {/* <Button sx={btnStyle} onClick={() => addShape('polygon', null, {
              drawing: true, fill: "white",
              stroke: "#ff0000",
              strokeWidth: 1,
              draggable: true
            })}><BsPentagon title="Polygon" /></Button> */}
          </ButtonGroup>
        </Box>
        <Box sx={{ px: 1, width: '80%', py: 3 }}>
          <TransformerProvider>
            <Canvas
              clear={selectedIds}
              shapes={shapes}
              selectedShape={shape}
              setShapes={setShapes}
              onSelect={(ids) => { setSelectedIds(ids); console.log("Selectedids", ids) }}
              download={download}
              selectedIds={selectedIds}
              type={shapeType}
              setShapeType={setShapeType}
              filters={filter}
              imgSrc={dynaSrc}
              trigerRef={trigerRef}
              downloadName={selectedCamera.camera_name}
              // markups={}
              onSave={(base64, download) => {
                if (download == "share") {
                  setShareSrc(base64)
                  return
                }
                let payload = { image: base64, camera: selectedCamera?.id }
                dispatch({
                  type: `${MARKUP}_POST`, payload, callback: () => {
                    getMarkup(selectedCamera?.id)
                  }
                });
              }}
              setTool={setTool}
            />
          </TransformerProvider>
        </Box>
        <Box className="tool-bar" sx={{ minWidth: 207, p: 2, }}>
          <Box display={'flex'} flexDirection={'column'} gap={2} justifyContent={'space-between'} sx={{ height: '50%' }}>
            <Typography fontSize={16} sx={{ fontWeight: 500, color: '#e5e0e0ff' }}>Recent Markups</Typography>
            <Box sx={{ borderRadius: 1, width: 1, border: '0.5px solid #606060' }}>
              {(markupallState?.data?.results || []).map((m) => {
                return <Box onClick={() => {
                  setDynaSrc(m.image_path)
                }} sx={{ display: 'flex', gap: 4, alignItems: 'center', p: 1, width: 1, fontSize: 10, borderBottom: '0.5px solid #606060', color: '#afaaaaff' }}>
                  <img src={m.image_path} height={30} /> <label>{m.file_name}</label>
                </Box>
              })}
              {(markupallState?.data?.results || [])?.length == 0 && <Box sx={{ p: 1, width: 1, fontSize: 10, borderBottom: '0.5px solid #606060', color: '#afaaaaff' }}>No markup found</Box>}
            </Box>
            <Box sx={{ height: '50%' }}>
              <Typography fontSize={16} sx={{ fontWeight: 500, color: '#e5e0e0ff' }}>Moving Tool</Typography>
              <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                <Box>
                  <Box sx={{ height: 150 }}></Box>
                  <NaviBox icons={naviIcons} pan_tilt_only={true} onChange={(status) => onNaviChange(status)} />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ color: 'white' }}>
                <Typography>x: {tool.x}</Typography>
                <Typography>y: {tool.y}</Typography>
              </Box>
              <Box>
                <Typography fontSize={16} sx={{ fontWeight: 500, color: '#e5e0e0ff' }}>Zoom</Typography>
                <Box sx={{ px: 2, mt: 1 }}>
                  <NaviBox zoom={tool.zoom} icons={naviIcons} zoom_only={true} onChange={(status) => onNaviChange(status)} />
                </Box>
                <ZoomSlider onChange={(value, direction) => onNaviChange((direction < 0 ? "zoom-out" : "zoom-in"))} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box >
  );
}

